import React from 'react';
import { Tag } from 'antd';

const statusColors = {
    CERTIFIED: '#99BD39',
    OK: '#FF9431',
};

const StatusTag = ({ status }) => {
    return <Tag color={statusColors[status]}>{status === 'CERTIFIED' ? status : 'VERIFIED'}</Tag>;
};

export default StatusTag;
